import { fetchAssignment } from '@core/assignments/api/fetch';
import { HANDIN_PROVIDER } from '@core/assignments/constants';
import { Assignment } from '@core/assignments/types';
import { accessToken as getAccessToken } from '@core/selectors/user';
import { institutionShortName } from '@core/selectors/institution';
import { goToReports } from '@app/actions/navigation';
import { getStore } from '@app/store';
import { AulaState } from '@core/types/state';

export type LaunchHandinParams = {
  assignmentId?: string;
  spaceId?: string | null;
  submissionId?: string | null;
  studentId?: string | null;
  isAnonymised?: boolean;
};

export type AssignmentWithSubmission = Assignment & {
  submission?: Array<{ objectId: string }>;
};

export const getAssignmentProvider = (assignment?: Assignment) => {
  if ((assignment?.provider as string) === 'handin') {
    return HANDIN_PROVIDER;
  }

  return assignment?.provider;
};

export const resolveHandinExternalId = async (
  assignment: Assignment,
  spaceId: string
) => {
  if (assignment.externalId) {
    return assignment.externalId;
  }

  const assignmentId = assignment.objectId || assignment.id;
  const accessToken = getAccessToken(
    getStore().getState() as AulaState,
    spaceId
  );

  if (!assignmentId || !accessToken) {
    return undefined;
  }

  const result = await fetchAssignment({
    accessToken,
    assignmentId,
  });

  return result?.data?.assignment?.externalId;
};

export const launchHandin = ({
  assignmentId,
  spaceId,
  submissionId,
  studentId,
  isAnonymised,
}: LaunchHandinParams) => {
  if (!assignmentId || !spaceId) {
    return;
  }

  const institution = institutionShortName(getStore().getState() as AulaState);
  const baseHandinURL =
    process.env.TEST_ENV === 'cypress'
      ? `https://handin.local.aula.education/${spaceId}/${assignmentId}`
      : `https://handin.${institution}.aula.education/${spaceId}/${assignmentId}`;

  let url = baseHandinURL;
  if (isAnonymised && submissionId) {
    url = `${baseHandinURL}/submissions/${submissionId}`;
  } else if (studentId) {
    url = `${baseHandinURL}/submissions/student/${studentId}`;
  }

  window.open(url, '_blank');
};

export const launchQuizzes = ({
  assignment,
  spaceId,
}: {
  assignment: AssignmentWithSubmission;
  spaceId: string;
}) => {
  const submission = assignment.submission;

  if (!submission?.length || !assignment.endDate) {
    return;
  }

  if (new Date() > new Date(assignment.endDate)) {
    getStore().dispatch(
      goToReports({
        assignmentId: assignment.id,
        spaceId,
        submissionId: submission[0].objectId,
        reportType: 'feedback',
      })
    );
  }
};

export const launchTurnitin = (
  assignment: Assignment,
  onLaunch: (assignment: Assignment) => void
) => {
  onLaunch(assignment);
};

export const launchLti1p3 = (
  assignment: Assignment,
  onLaunch: (assignment: Assignment) => void
) => {
  onLaunch(assignment);
};
